import { Component } from '@angular/core';

@Component({
  selector: 'app-deals-report',
  templateUrl: './deals-report.component.html',
  styleUrls: ['./deals-report.component.scss']
})
export class DealsReportComponent {
  reports = [
    {
      name: "Today's Sales",
      description: "An overview of all sales made today, yesterday, last week, last month, and last year, providing a quick snapshot of sales performance.",
      lastAccessed: "14 min ago",
      slug: "todays-sales"
    },
    {
      name: "Deal Type Report",
      description: "Breakdown of deals based on type — New Business vs Existing Business — across various stages in the sales pipeline.",
      lastAccessed: "38 min ago",
      slug: "deal-type-report"
    },
    {
      name: "Sales by Lead Source",
      description: "Tracks sales performance based on lead sources such as tina, whatsapp, refer, and others, helping to identify the most effective channels.",
      lastAccessed: "12 min ago",
      slug: "sales-by-lead-source"
    },
    {
      name: "Pipeline by Stage",
      description: "Visualizes how deals are distributed across different stages of the sales pipeline, helping identify bottlenecks.",
      lastAccessed: "15 min ago",
      slug: "pipeline-by-stage"
    },
    {
      name: "Sales by User",
      description: "Displays individual sales performance metrics for each sales representative, including total deals closed.",
      lastAccessed: "1 hr ago",
      slug: "sales-by-user"
    },
    {
      name: "Closed Deals",
      description: "Lists all deals that have been successfully closed and converted into sales within a specified time frame.",
      lastAccessed: "1 hr ago",
      slug: "closed-deals"
    },
    {
      name: "Lost Deals",
      description: "Provides insights into deals that were lost, including reasons for loss and trends over time.",
      lastAccessed: "2 hrs ago",
      slug: "lost-deals"
    },
    {
      name: "Deals Closing this Month",
      description: "Forecast of deals expected to close by the end of the current month, aiding in short-term revenue planning.",
      lastAccessed: "18/04/2025",
      slug: "deals-closing-this-month"
    }
  ];

}
